export default __webpack_public_path__ + "static/header-d358a7a4844bf362812aba6c8596eb80.png";